import { CLASSROOM_MATERIAL_SECTION } from '../../constants/endpoints';
import request, { getData } from './request';
import toSection from './toSection';

const patchSection = async (classRoomId, sectionId, patch) => {
  const url = CLASSROOM_MATERIAL_SECTION(classRoomId, sectionId);
  const data = await request({
    method: 'patch',
    url,
    data: { section: patch },
  }).then(getData);
  const dataAsSection = toSection(data);
  return dataAsSection;
};

export default patchSection;
